// token缓存key
export const userKey = "Website_ADMIN_USER_KEY";

// 每页默认显示的数据量
export const PAGE_SIZE = 100;

// 统计数据时段类型
export const REAL_TIME_TYPE = {
  HOUR: 1,
  MONTH: 2,
  YEAR: 3,
};

// 码头列表
export const TERMINALS = [
  "FMS",
  "APM",
  "LBCT",
  "PierA",
  "WBCT",
  "ETS",
  "ITS",
  "YTI",
  "TraPac",
  "Matson",
  "PCT",
  "TTI",
];

// 码头还空列表
export const EMPTY_TERMINALS = [
  "LBCT",
  "WBCT",
  "PCT",
  "FMS",
  "APM",
  "ITS",
  "YTI",
  "TraPac",
  "TTI",
  "PierA",
];
